import { createContext, useContext } from "react";
import type { ChatSource, SourceFile } from "./messageSources";

const SourceFileContext = createContext<((file: SourceFile) => void) | undefined>(undefined);

/** Opens the files an answer used beside the chat (MHS-1040). Outside a chat, sources have no file to open. */
export const SourceFileProvider = SourceFileContext.Provider;

/** The action that opens a source's file here, or undefined: an answer saved before MHS-1040, or no chat to open it in. */
export function useSourceFileOpener(): (source: ChatSource) => (() => void) | undefined {
  const open = useContext(SourceFileContext);
  return (source) => {
    const file = source.file;
    return open && file ? () => open(file) : undefined;
  };
}
